import { useCallback, useState } from "react";

import { WEB_DOWNLOADS_INFO_COLLAPSED_STORAGE_KEY } from "../WebDownloadsManager.constants";

const readIsCollapsed = (): boolean => {
  try {
    return localStorage.getItem(WEB_DOWNLOADS_INFO_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const persistCollapsed = (): void => {
  try {
    localStorage.setItem(WEB_DOWNLOADS_INFO_COLLAPSED_STORAGE_KEY, "true");
  } catch {
    // ignore quota / private browsing
  }
};

const clearCollapsed = (): void => {
  try {
    localStorage.removeItem(WEB_DOWNLOADS_INFO_COLLAPSED_STORAGE_KEY);
  } catch {
    // ignore quota / private browsing
  }
};

export interface UseWebDownloadsInfoAccordionReturn {
  isExpanded: boolean;
  toggle: () => void;
}

export const useWebDownloadsInfoAccordion = (): UseWebDownloadsInfoAccordionReturn => {
  const [isExpanded, setIsExpanded] = useState(() => !readIsCollapsed());

  const toggle = useCallback((): void => {
    setIsExpanded((previousExpanded) => {
      if (previousExpanded) {
        persistCollapsed();
        return false;
      }

      clearCollapsed();
      return true;
    });
  }, []);

  return {
    isExpanded,
    toggle,
  };
};
